<script>
    import Vue from "vue";
    import $ from "jquery";

    export default {
        name: 'MailsApp',
        data: function() {
            return {
                siteid: null,
                count: 0,
                marked: [],
                chartOptions: {
                    colors:['#00aaff', '#aa0000', '#cccccc'],
                    legend: {
                        position: 'top',
                    },
                    chart: {
                        id: 'vuechart-stat',
                        defaultLocale: 'ru',
                        locales: [{
                            name: 'ru',
                            options: {
                                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                                shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сеп', 'Окт', 'Ноя', 'Дек'],
                                days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                                shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                                toolbar: {
                                    download: 'Скачать',
                                    selection: 'Выделить',
                                    selectionZoom: 'Масштаб',
                                    zoomIn: 'Увеличить',
                                    zoomOut: 'Уменьшить',
                                    exportToSVG: "Скачать SVG",
                                    exportToPNG: "Скачать PNG",
                                    pan: 'Panning',
                                    reset: 'Сбросить масштаб',
                                    menu: 'Скачать',
                                }
                            }
                        }],
                        toolbar: {
                            show: true,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: '&nbsp;',
                                zoomin: false, 
                                zoomout: false, 
                                reset: '<span class="fa fa-search"></span>',
                                pan: false,
                                customIcons: []
                            },
                            autoSelected: 'zoom' 
                        },
                        animations: {
                            enabled: false,
                            easing: 'easeinout',
                            speed: 800,
                            animateGradually: {
                                enabled: true,
                                delay: 150
                            },
                            dynamicAnimation: {
                                enabled: true,
                                speed: 350
                            }
                        }
                    },
                    stroke: {
                        show: true,
                        lineCap: 'butt',
                        colors: undefined,
                        width: 2,
                        curve: ['straight', 'straight', 'smooth'],
                        dashArray: 0,      
                    },
                    xaxis: {
                        type: 'datetime',
                    },
                    yaxis: [

                   ],
                   tooltip: {
                       shared: true,
                       y: {
                           formatter: function (y) {
                               if(typeof y !== "undefined") {
                                   return  y.toFixed(0);
                               }
                               return y;
                           }
                       },
                   }
                },
                chartSeries: [],
                chartReady: false,
            }
        },
        mounted: function() {
            let app = this;
            const series = JSON.parse(app.$root.$el.dataset.series);

            this.siteid = this.$root.$el.dataset.siteid;
            this.count = this.$root.$el.dataset.count;


            let cache = localStorage.getItem(`mailstat-${app.siteid}`);
            if (cache) {
                cache = JSON.parse(cache);
                if (cache.expires > Date.now()) {
                    console.log('fromcache');
                    app.syncChart(cache.data, series);
                    return
                }
            }

            $.post( `/mails/${this.siteid}/stat/`, {'series[]': series}, function(data) {
                app.syncChart(data, series);
            })


        },
        methods: {
            manage: function(action, message) {
                let ap = this;
                this.$dialog.confirm(message).then(
                    function(dialog) {
                        $.ajax({
                            type: "POST",
                            url: '/mails/'+ap.siteid+'/manage/',
                            data: {'action': action, 'mails': ap.marked},
                            success: function ( data ) {
                                document.location.reload(false);
                            },
                            error: function(error) {
                                alert('Ошибка при выполнении операции');
                                return;
                            }
                        });
                    }
                ).catch(
                    function() {
                    }
                );
            },
            markAll: function() {
                let ap = this;

                if (this.marked.length == 0) {
                    $.each($('input.id-mark'), function(){
                        ap.marked.push($(this).val());
                    });
                } else {
                    ap.marked = [];
                }
                console.log(this.marked);
            },
            syncChart: function(data, series) {
                const subscribed = data.subscribed;
                const unsubscribed = data.unsubscribed;
                const active = data.active;

                let yaxis = [];
                let colors = [];

                if(subscribed.length && series.includes('subscribed')){ 
                    this.chartSeries.push({
                        name: 'Подписались',
                        type: 'line',
                        data: subscribed,
                        show: true,
                    });
                    yaxis.push({
                        seriesName: 'Подписались',
                        show: true,
                    });
                    colors.push('#00aaff');
                }
                if(unsubscribed.length && series.includes('unsubscribed')){ 
                    this.chartSeries.push({
                        name: 'Отписались',
                        type: 'line',
                        data: unsubscribed,
                        show: true,
                    });
                    yaxis.push({
                        seriesName: 'Отписались',
                    });
                    colors.push('#aa0000');
                }

                if(active.length && series.includes('active')){ 
                    this.chartSeries.push({
                        name: 'Всего подписчиков',
                        type: 'area',
                        data: active,
                        show: true,
                    });
                    yaxis.push({
                        seriesName: 'Всего подписчиков',
                        opposite: true,
                        logarithmic: false,
                    });
                    colors.push('#cccccc');
                }

                Vue.set(this, 'chartOptions', {...this.chartOptions, ...{yaxis: yaxis, colors: colors}});
                this.chartReady = true;
                localStorage.setItem(`mailstat-${this.siteid}`, JSON.stringify({data: data, expires: Date.now()+60*60*1000}));
            }
        }
    }
</script>
